import store from '../../store'
import {createContactRequest} from '../../actions/contacts'

export function createContact(name,company,email) {	
	return store.dispatch(createContactRequest(name,company,email))
}

